import { useState, useRef } from 'preact/hooks';
import type { TemplateProps } from '../types';
import { ChatIcon } from '../../components/ChatIcon';

export function Trigger({ config, onSend, onOpen }: TemplateProps): preact.JSX.Element {
  const [dismissed, setDismissed] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChipClick = (question: string): void => {
    onSend(question);
    onOpen();
  };

  const handleInputSubmit = (): void => {
    const val = inputRef.current?.value?.trim();
    if (val) {
      onSend(val);
      onOpen();
    }
  };

  const handleInputKeyDown = (e: KeyboardEvent): void => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleInputSubmit();
    }
  };

  const handleDismiss = (e: Event): void => {
    e.stopPropagation();
    setDismissed(true);
  };

  if (dismissed) {
    return (
      <button
        class="yd-greeting-fallback-bubble"
        onClick={(e: Event) => { e.stopPropagation(); onOpen(); }}
        aria-label="Open chat"
      >
        <ChatIcon size={20} />
      </button>
    );
  }

  return (
    <div class="yd-greeting-card" onClick={(e: Event) => e.stopPropagation()}>
      <button
        class="yd-greeting-dismiss"
        onClick={handleDismiss}
        aria-label="Dismiss"
        title="Dismiss"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>

      {config.logo_url && (
        <div class="yd-greeting-avatar-wrap">
          <img class="yd-greeting-avatar" src={config.logo_url} alt={config.name} />
        </div>
      )}

      <div class="yd-greeting-welcome">
        {config.welcome_message || `Hi! I'm ${config.name}. How can I help you today?`}
      </div>

      {config.suggested_questions?.length > 0 && (
        <div class="yd-greeting-chips">
          {config.suggested_questions.map((q) => (
            <button
              key={q}
              class="yd-greeting-chip"
              onClick={() => handleChipClick(q)}
            >
              {q}
            </button>
          ))}
        </div>
      )}

      <div class="yd-greeting-input-row">
        <input
          ref={inputRef}
          class="yd-greeting-input"
          type="text"
          placeholder="Type a question..."
          onKeyDown={handleInputKeyDown}
        />
        <button
          class="yd-greeting-send"
          onClick={handleInputSubmit}
          aria-label="Send"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
